import React from 'react';
// import { useTranslation } from 'react-i18next';
// import { Button } from '@mui/material';
// import { VOICE_OWNERSHIP } from '@src/constants/voice';
import { StyledVoiceButtonAction } from './index.style';

const ButtonAction = () => (
  // const { t } = useTranslation();
  // const [selectedFilter, setSelectedFilter] = useState('all');

  // const handleButtonClick = (value) => {
  //   setSelectedFilter(value);
  //   const newSearch = { ...search, [name]: value };
  //   if (value === 'all') {
  //     newSearch.voiceOwnership = null;
  //   } else if (value === 'vbee') {
  //     newSearch.voiceOwnership = VOICE_OWNERSHIP.VBEE;
  //   } else if (value === 'public') {
  //     newSearch.voiceOwnership = VOICE_OWNERSHIP.COMMUNITY;
  //   }
  //   onChange(newSearch);
  // };

  <StyledVoiceButtonAction>
    <div className="top-action-detail">
      {/* <Button
          variant="outlined"
          className={`button-action ${
            selectedFilter === 'all' ? 'active' : ''
          }`}
          onClick={() => handleButtonClick('all')}
        >
          {t('all')}
        </Button> */}

      {/* <Button
          variant="outlined"
          className={`button-action ${
            selectedFilter === 'vbee' ? 'active' : ''
          }`}
          onClick={() => handleButtonClick('vbee')}
        >
          {t('voiceVbee')}
        </Button>

        <Button
          variant="outlined"
          className={`button-action ${
            selectedFilter === 'public' ? 'active' : ''
          }`}
          onClick={() => handleButtonClick('public')}
        >
          {t('voiceCommunity')}
        </Button> */}
    </div>
  </StyledVoiceButtonAction>
);
export default ButtonAction;
